import type { NDateLocale } from './enUS'
import { enIN } from 'date-fns/locale'

const dateNeNP: NDateLocale = {
  name: 'ne-NP',
  locale: enIN
}

export default dateNeNP
